import { SurveyCriteriaManagerReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

export class SurveyCriteriaManagerDialogViewModel
{
    opened: boolean = false;

    rm: SurveyCriteriaManagerReadModel | null = null;
    surveyId: number | null = null;
    surveyName: string | null = null;

    show(surveyId: number, surveyName: string)
    {
        this.surveyId = surveyId;
        this.surveyName = surveyName;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.rm = null;
    }

    setData(rm: SurveyCriteriaManagerReadModel)
    {
        this.rm = rm;
    }
}